module.exports = __webpack_public_path__ + "img/drag_group_color_hove.b9727ed4.png";